import React from 'react';
import PropTypes from 'prop-types';

import { Table, Column, Cell } from 'fixed-data-table-2';
import TableMixin from '../../components/TableMixin/TableMixin';
import TextCell from '../../components/TextCell/TextCell';
import SortableHeaderCell from '../../components/SortableHeaderCell/SortableHeaderCell';
import CTableActions from '../../containers/CTableActions/CTableActions';
import CSensorsSettings from '../../containers/CSensorsSettings/CSensorsSettings';
import { DateType } from '../../containers/UIhelper/UIDateFormater';

class SOPsTable extends React.Component {

  render() {

    const { items, indexMap, selectedFeature, user, optionList, pHeight, pWidth, sortProp, rowClickEvent, goToRow, rowClassNameGetter, t } = this.props;
    const sopStateOptions = {};
    const sopTypeOptions = {};
    if (optionList.options.SopStatuses != null) {
      optionList.options.SopStatuses.forEach(state => {
        sopStateOptions[state.value] = state.DisplayName || state.label;
      });
    }
    if (optionList.options.AqsCode) {
      optionList.options.AqsCode.forEach((type) => {
        sopTypeOptions[type.value] = type.DisplayName || type.label;
      })
    }
    //document.title = 'AQS • Alerts';

    const totalItemsStyle = {
      float: 'right',
      padding: '2px 8px',
    };

    return (
      <div>
        <Table
          maxHeight={pHeight - 93}
          width={pWidth}
          rowsCount={items.length}
          rowHeight={30}
          headerHeight={30}
          onRowClick={rowClickEvent}
          rowClassNameGetter={this.props.rowClassNameGetter}
          scrollToRow={goToRow}
          {...this.props}
        >
          <Column
            columnKey="id"
            width={100}
            flexGrow={1}
            header={<SortableHeaderCell sortTable={sortProp} />}
            cell={<TextCell data={items} field="id" />} />
          <Column
            columnKey="Type"
            width={100}
            flexGrow={1}
            header={<SortableHeaderCell sortTable={sortProp} />}
            cell={<TextCell data={items} field="AvizarCode" options={sopTypeOptions} />} />
          <Column
            columnKey="State"
            width={100}
            flexGrow={1}
            header={<SortableHeaderCell sortTable={sortProp} />}
            cell={<TextCell data={items} field="State" options={sopStateOptions}/>} />
          <Column
            columnKey="StreetAddress"
            width={100}
            flexGrow={3}
            header={<SortableHeaderCell sortTable={sortProp} />}
            cell={<TextCell data={items} field="StreetAddress" />} />
          <Column
            columnKey="AssetID"
            width={100}
            flexGrow={3}
            header={<SortableHeaderCell sortTable={sortProp} />}
            cell={<TextCell data={items} field="AssetID" />} />
          <Column
            columnKey="Model"
            width={100}
            flexGrow={3}
            header={<SortableHeaderCell sortTable={sortProp} />}
            cell={<TextCell data={items} field="Model" />} />
        </Table>

        {items && items.length > 0 &&
          <CTableActions
            type="sops"
            notify={this.props.notify}
          />
        }
        {items && items.length > 0 &&
          <span style={totalItemsStyle}>{t('selected_selectedindex_total_total', { selectedIndex: (indexMap[selectedFeature] + 1) || 0, total: items.length })}</span>
        }

      </div>
    );
  }
}

SOPsTable = TableMixin(SOPsTable, CSensorsSettings);
export default SOPsTable;
